<template>
   <div>
      <div class="center">
         <img src="../../../assets/images/neirongnull.png" alt="">
         <br>
         <span>当前内容为空</span>
      </div>
      <div class="anniu">
            <el-row>
                <el-button class="fanhui" style="margin-right:10px" @click="goback">返回</el-button>
                <el-button class="shuxin" @click="refresh">刷新</el-button>
            </el-row>
        </div>
   </div>
</template>

<script>
export default {
   methods: {
      goback(){
         this.$router.go(-1)
      },
      refresh(){
         this.$router.go(0)
      }
   },
   data(){
      return {

      }
   }
}
</script>

<style scoped>
   .anniu{
      padding-top: 20px;
   }
   .center, .anniu{
      text-align: center;
   }
   span{
      letter-spacing: 2px;
      font-size: 18px;
      color: rgb(83, 83, 83)
   }
   .fanhui{
      padding: 12px 35px;
      border: 1px solid rgb(184, 184, 184);
   }
   .shuxin {
      background-color: #006aca;
      color: white;
      padding: 12px 35px;
   }
</style>
